import axiosInstance from './AxiosInstance';

class ModuleService {

    constructor() {
        this.endpoint = "/api/modules"
    }

    async getAll(params) {
        try {
            const response = await axiosInstance.get(this.endpoint);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}

const moduleService = new ModuleService();

export { moduleService };